export const OPENCLOSE_SIDEMENU = "OPENCLOSE_SIDEMENU";
export const OPEN_FORMMENU = "OPEN_FORMMENU";
export const OPEN_USUARIOS = "OPEN_USUARIOS";

export const UPLOADING_IMAGE = "UPLOADING_IMAGE";

export const LOAD_ACTIVITIES = "LOAD_ACTIVITIES";
export const OPEN_ACTIVITIES = "OPEN_ACTIVITIES";

export const LOAD_USERS = "LOAD_USERS";

export const OPEN_INFORMATIONS = "OPEN_INFORMATIONS";
export const LOAD_INFORMATIONS = "LOAD_INFORMATIONS";

export const LOAD_FAVOURITES = "LOAD_FAVOURITES";
export const OPEN_FAVOURITES = "OPEN_FAVOURITES";

export const LOAD_PROMOTIONS = "LOAD_PROMOTIONS";

export const OPEN_PROMOTIONS = "OPEN_PROMOTIONS";

export const LOAD_PRINCIPAL = "LOAD_PRINCIPAL";

export const OPEN_PRINCIPAL = "OPEN_PRINCIPAL";
